export default __webpack_public_path__ + "static/media/hotstar.8d00677a.png";